if ( window.wp && window.wp.ajax ) {

    const { registerBlockType } = window.wp.blocks;
    const { RawHTML } = window.wp.element;
    
    const { 
        RichText,
        InspectorControls,
        MediaUpload,
    } = window.wp.editor;
    
    const { 
        PanelBody, 
        IconButton, 
        TextControl,
        Button
    } = window.wp.components;

    registerBlockType('custom-gutenberg/content-card', {
        // built-in attributes
        title: 'Content card',
        description: 'Content card',
        icon: 'slides',
        category: 'custom-components',
        example: {},

        // custom attributes
        attributes: {
            link: {
                type: 'string',
                default: '',
            },
            backgroundImage: {
                type: 'string',
                default: ''
            }, 
            title: {
                type: 'string',
                default: ''
            },
            description: {
                type: 'string',
                default: ''
            },
            btnText: {
                type: 'string',
                default: 'Saznaj više'
            },
            headingTag: {
                type: 'string',
                default: 'h2'
            },
        },

        // built-in functions
        edit({ attributes, setAttributes }) {

            const {
                link,
                backgroundImage,
                title,
                description,
                btnText,
                headingTag
            } = attributes;

            // custom functions
            function onLinkChange (link) {
                setAttributes({link: link});
            };

            function onSelectImage (image) {
                setAttributes({backgroundImage: image.sizes.full.url});
            }

            function onTitleChange(title) {
                setAttributes({title: title});
            }

            function onDescriptionChange(description) {
                setAttributes({description: description});
            }

            function onBtnTextChange(btnText) {
                setAttributes({btnText: btnText});
            }

            return ([
                <InspectorControls style={ { marginBottom: '40px' } }>
                    <PanelBody title={ 'Link' }>
                        <p><strong>Enter url: (ex: /smještaj)</strong></p>
                        <TextControl value={ link } onChange={ onLinkChange }></TextControl>
                    </PanelBody>
                    <PanelBody title={ 'Background Image Settings' }>
                        <MediaUpload 
                            onSelect={ onSelectImage }
                            type="image"
                            value={ backgroundImage } 
                            render={ ( { open } ) => (
                                <div>
                                    { backgroundImage && 
                                        <div>
                                            <figure>
                                                <img src={backgroundImage} />
                                            </figure>
                                            <div>
                                                <Button onClick={() => setAttributes({ backgroundImage: '' })} className="button">Remove</Button>
                                            </div>
                                        </div>
                                    }
                                    
                                <IconButton
                                    onClick={ open }
                                    icon="upload"
                                    classNames="editor-media-placeholder__button is-button is-default is-large">
                                    Select Background Image
                                </IconButton>
                                </div>
                            ) } />
                    </PanelBody>
                    <PanelBody title={ 'Slide Content' }>
                        <p><strong>Title</strong></p>
                        <TextControl value={ title } onChange={ onTitleChange }></TextControl>
                    </PanelBody>
                </InspectorControls>
                ,
                <div class="card content-card">
                    <div class="card-content">
                        <div class="cover-image" style={{ backgroundImage: `url(${backgroundImage})` }}>
                            <div class="title"> 
                                <RichText 
                                    key="editable" 
                                    className="z-1"
                                    placeholder="Title" 
                                    value={ title }
                                    onChange={ onTitleChange } />
                            </div>
                        </div>
                    </div>
                </div>
            ]
            );
        },

        save({ attributes }) {

            const {
                link,
                backgroundImage,
                title,
            } = attributes;

            return (
                <a href={ link } className="card content-card" >
                    <div className="card-content">
                        <div className="lozad cover-image" data-background-image={ backgroundImage }>
                            <div className="title"> 
                                <div className="z-1">
                                    { title }
                                </div>
                            </div>
                        </div>
                    </div>
                </a>
            );
        },
    });
}